/**
 * @author: dongjing
 * @file: description
 * @Date: 2019-12-02 12:03:03
 * @LastEditors: dongjing
 * @LastEditTime: 2019-12-09 21:31:02
 */
import { homeModelState } from './homeModel';
import { appModelState } from './appModel';

const initialState = {
  ...homeModelState,
  ...appModelState
};

export type IInitialState = Readonly<typeof initialState>;

export default initialState;
